import * as Yup from 'yup'

export const globalControlsValidationSchema = Yup.object({
  platformDailyMaxCount: Yup.number().min(0, 'Must be 0 or greater').required('Required'),
  platformDailyMaxAmountBase: Yup.number().min(0, 'Must be 0 or greater').required('Required'),
  clientDailyMaxCount: Yup.number().min(0, 'Must be 0 or greater').required('Required'),
  clientDailyMaxAmountBase: Yup.number().min(0, 'Must be 0 or greater').required('Required'),
  globalCurrencyLimits: Yup.array().of(
    Yup.object({
      currencyId: Yup.string().required('Currency is required'),
      maxAmount: Yup.number().moreThan(0, 'Must be greater than 0').required('Required'),
    })
  ),
})
